import { Box, FormControl, MenuItem, Select, Skeleton, Typography } from '@mui/material'
import useFetchGruposBalance from 'common/hooks/useFetchGruposBalance'
import i18n from 'lang/idiomas'
import { useEffect, useState } from 'react'

const SelectorGruposBalance = ({
  grupoBalance = '',
  handleChange = () => {},
  label = i18n.t('efactura.grupbal', { defaultValue: 'Grupo Balance' }),
  sx = {},
  error = false,
}) => {
  const [gruposBalance, setGruposBalance] = useState([])
  const { response, loading } = useFetchGruposBalance()

  useEffect(() => {
    setGruposBalance(response)

    if (response?.length === 1) {
      handleChange(response[0].codigo)
    }
  }, [response, handleChange])

  return (
    <Box id="box-selector-grupos-balance" sx={{ ...sx }}>
      {loading ? (
        <Skeleton variant="rounded" sx={{ width: '100%' }} height={56} />
      ) : (
        !loading &&
        gruposBalance?.length > 1 && (
          <FormControl fullWidth error={error}>
            <Typography variant="body1">{label}</Typography>

            <Select
              id="selector-grupos-balance"
              displayEmpty
              value={grupoBalance}
              onChange={(e) => {
                handleChange(e.target.value)
              }}
            >
              <MenuItem value="">
                {i18n.t('efactura.selgruba', { defaultValue: 'Selecciona un grupo' })}
              </MenuItem>
              {!loading &&
                gruposBalance.map((item) => (
                  <MenuItem key={item.codigo} value={item.codigo}>
                    {item.descripcion}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )
      )}
    </Box>
  )
}

export default SelectorGruposBalance
